import styled from "styled-components";

export const DonationNavBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 0;
  margin-left: auto;
  margin-right: auto;
`

export const DonationNavBarRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 70px;
`

export const DonationNavBarLogoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const DonationNavBarLogo = styled.img`
  @media (min-width: 800px) {
    height: 50px;
    padding-right: 15px;
  }

  @media (max-width: 800px) {
    height: 40px;
    padding-right: 10px;
  }
`

export const DonationBenevPay = styled.h1`
  margin: 0;
  padding: 0 5px 0 0;
  @media (min-width: 800px) {
    font-size: var(--font-size-xl);
  }

  @media (max-width: 800px) {
    font-size: var(--font-size-md);
  }
`

export const DonationNavBarUserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;

  @media (max-width: 800px) {
    font-size: var(--font-size-sm);
  }
`

export const DonationNavBarAccount = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`

export const DonationNavBack = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const DonationNavBackClick = styled.div`
  display: flex;
  align-items: center;
  color: var(--color-navigation);
  font-weight: 500;
  cursor: pointer;
  margin: 5px 0 20px 0;
  &:hover {
      color: var(--color-tool-bar-bg);
  }
`
